import React from 'react';
import * as PropTypes from 'prop-types';
import { ReactComponent as AmericanExpress } from './assets/american_express.svg';
import { ReactComponent as ChinaUnionpay } from './assets/china_unionpay.svg';
import { ReactComponent as DinersClub } from './assets/diners_club.svg';
import { ReactComponent as Discover } from './assets/discover.svg';
import { ReactComponent as Mir } from './assets/mir.svg';
import { ReactComponent as Maestro } from './assets/maestro.svg';
import { ReactComponent as MaskGroup } from './assets/mask_group.svg';
import { ReactComponent as Mastercard } from './assets/mastercard.svg';
import { ReactComponent as Uec } from './assets/uec.svg';
import { ReactComponent as Visa } from './assets/visa.svg';

export function BankCardIcon({ number }) {
  if (/^30|^36|^38/.test(number)) {
    return <DinersClub />;
  }
  if (/^31|^35/.test(number)) {
    return <MaskGroup />;
  }
  if (/^34|^37/.test(number)) {
    return <AmericanExpress />;
  }
  if (/^50|^56|^57|^58|^63|^67/.test(number)) {
    return <Maestro />;
  }
  if (/^51|^52|^53|^54|^55/.test(number)) {
    return <Mastercard />;
  }
  if (/^60/.test(number)) {
    return <Discover />;
  }
  if (/^62/.test(number)) {
    return <ChinaUnionpay />;
  }
  if (/^2\d/.test(number)) {
    return <Mir />;
  }
  if (/^4\d/.test(number)) {
    return <Visa />;
  }
  if (/^7\d/.test(number)) {
    return <Uec />;
  }
  return null;
}

BankCardIcon.propTypes = {
  number: PropTypes.string,
};
BankCardIcon.defaultProps = {
  number: '',
};
